import React from "react";
import "./MetaLiftBestPractices.scss";

const MetaBestPractices = (): JSX.Element => {
  return (
    <div className="metaLiftTestBestPractices">
      {" "}
      <div className="metaLiftTestBestPracticesHeader">Test Setup Best Practices</div>
      <div className="metaLiftTestBestPracticesList">
        <div className="metaLiftTestBestPracticesListText">
          {"\u2022"} Before beginning to fill in test details, make sure you have clearly
          articulated the question(s) you want to answer, have a hypothesis for the test outcome and
          clearly planned actions based on whether those hypotheses are true or not.
        </div>
        <div className="metaLiftTestBestPracticesListText">
          {"\u2022"} Each test requires one or more test cells. You should create additional cells
          when you want to compare the incrementality of two or more different strategies. Each cell
          of a test will get its own readout once the test is complete.
        </div>
        <div className="metaLiftTestBestPracticesListTextSpace">
          {"\u2022"} Example of a single-celled test: A one-celled test containing all retargeting
          campaigns to determine whether there is a significant difference between retargeting’s
          incremental performance and platform attributed performance.
        </div>
        <div className="metaLiftTestBestPracticesListTextSpace">
          {"\u2022"} Example of a two-celled test: A comparison of a BAU conversion optimized
          campaign against a new campaign using value optimization to determine which optimization
          strategy drives higher incremental ROAS.
        </div>
        <div className="metaLiftTestBestPracticesListText">
          {"\u2022"} Avoid audience overlap between campaigns or ad sets that are included in your
          lift study and campaigns or ad sets that are not. For example, if you have multiple
          prospecting campaigns with broad targeting and you include one of them in a lift study,
          you should include all of them so that users in the holdout group cannot get impressions
          from any campaigns not included in the study.
        </div>
      </div>
    </div>
  );
};

export default MetaBestPractices;
